var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAa = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 37 39"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFCC01",
  d: "M.26 1.218h36.549v36.549H.26z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1D1D1D",
  fillRule: "evenodd",
  d: "M30.737 27.711h-3.4v-3.436H22.77l-1.61 3.436h-3.47L26.093 9.84h4.643zm-3.418-6.69v-6.395l-2.997 6.396zm-9.702 6.69h-3.435v-3.436H9.65l-1.607 3.437H4.533l8.443-17.873h4.641zm-3.451-6.69v-6.395l-2.999 6.396z",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.26 0h36.549v38.985H.259z"
})))));
export { SvgAa as ReactComponent };
export default new URL("/home/runner/_work/motorway-seller-webapp/motorway-seller-webapp/src/client/assets_seller/partners/aa.svg", import.meta.url).toString();